import { Button, Card, CardContent, PageHeader, Spinner } from '@estac1/ui';
import { AlprReviewCard } from './alpr-review/review-card.js';
import { useAlprReview } from './alpr-review/use-alpr-review.js';

/**
 * Superadmin review queue for ALPR training labels (#183).
 * Enter confirms prediction; type a plate + save to correct; reject drops sample.
 */
export const AlprReviewScreen = () => {
  const {
    queue,
    samples,
    current,
    index,
    setIndex,
    correction,
    setCorrection,
    review,
    exportJsonl,
  } = useAlprReview();

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <PageHeader
        title="ALPR — revisão"
        description="Confirme ou corrija a placa lida. Prioridade de treino: Mercosul (ABC1D23). Enter confirma a predição."
        actions={
          <Button variant="outline" size="sm" className="w-full sm:w-auto" onClick={exportJsonl}>
            Exportar Mercosul verified
          </Button>
        }
      />

      {queue.isLoading ? (
        <Spinner />
      ) : samples.length === 0 ? (
        <Card>
          <CardContent className="py-10 text-center text-sm text-muted-fg">
            Nenhuma amostra pendente. Leituras de OCR entram aqui automaticamente.
          </CardContent>
        </Card>
      ) : current ? (
        <AlprReviewCard
          current={current}
          index={index}
          total={samples.length}
          correction={correction}
          onCorrectionChange={setCorrection}
          review={review}
          onSkip={() => setIndex((i) => i + 1)}
        />
      ) : null}
    </div>
  );
};
